import { StatusCode } from 'types/statusCodes'
import { env } from 'utils/envManager'
import { formatCustomDate } from 'utils/formatCustomDate'

export const fetcher = async (
	endpoint: string,
	language: string,
	optional?: {
		collection?: string
		customDate: Date | null
	},
	isClient = false
) => {
	const basePath = isClient
		? `${env.NEXT_PUBLIC_SITE_BASE_URL}/ws-product-lists/v1`
		: `${env.PLP_SERVICE}/v1`
	const url = new URL(`${basePath}${endpoint}`)
	const params: Record<string, string> = { language }
	/** Optional params: */

	if (optional?.collection) {
		params.collection = optional.collection
	}

	/** When environment is 'shoptest' */
	// TODO: get shoptest environment check
	// if (isTestEnvironment) {
	// 	params.test = 'true'
	// }

	/** When timestamp param different to now is defined */
	const optionalCustomDateHeader = optional?.customDate
		? {
				'x-custom-date': formatCustomDate(optional.customDate),
			}
		: undefined

	// TODO: provisional parameter while url-reader is fixed
	params.genesis = 'true'

	url.search = new URLSearchParams(params).toString()
	let response
	try {
		response = await fetch(url.href, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				...optionalCustomDateHeader,
			},
			next: {
				revalidate: 0,
			},
		})
	} catch (error) {
		console.error('Error', error)
	}

	if (response?.status === StatusCode.NOT_FOUND) {
		return null
	}

	if (!response?.ok) {
		throw new Error(`Error ${response?.status} ${url.href}`)
	}

	return response.json()
}
